class CompleteLook extends HTMLElement {
  connectedCallback() {
    const swiperContainer = this.querySelector("[complete-look-slider]");
    if (!swiperContainer) return;

    const slides = swiperContainer.querySelectorAll(
      "[complete-look-swiper-slide]",
    );
    if (slides.length < 1) return;

    const slidesPerViewDesktop =
      parseInt(swiperContainer.getAttribute("data-slides-per-view")) || 4;
    const slidesPerViewMobile =
      parseInt(swiperContainer.getAttribute("data-slides-per-view-mobile")) ||
      2;

    new Swiper(swiperContainer, {
      slidesPerView: slidesPerViewDesktop,
      loop: false,
      spaceBetween: 0,
      simulateTouch: true,
      touchStartPreventDefault: false,
      scrollbar: {
        el: this.querySelector("[complete-look-swiper-scrollbar]"),
        draggable: true,
        hide: false,
      },
      breakpoints: {
        0: {
          slidesPerView: slidesPerViewMobile + 0.9,
          spaceBetween: 1,
        },
        768: {
          slidesPerView: slidesPerViewDesktop,
          spaceBetween: 4,
        },
      },
    });
  }
}

customElements.define("complete-look", CompleteLook);
